// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__1gq6m","content":"LayoutSettings_content__2PjBl"};